<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <NeList ref='neGms' :neArr='netype' :select='neClick'></NeList>
    </template>
    <template v-slot:right_view>
      <GroupTableMenu @methodEnum='methodEnum'></GroupTableMenu>
      <GroupTable ref="grouptable"></GroupTable>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../../layouts/BasicLayout';
import GroupTableMenu from '../../../../components/subscriberconfig/mcsSubscriber/group/GroupTableMenu';
import GroupTable from '../../../../components/subscriberconfig/mcsSubscriber/group/GroupTable';
import NeList from '../../../../components/common/NeList';

export default {
  name: 'GroupMainPage',
  components: {
    BasicLayout,
    GroupTableMenu,
    GroupTable,
    NeList
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t('SubscriberIms.neList')
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t('SubscriberIms.menuTitleGroupMcs')
      },
      netype: [
        14
      ]
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'add':
          this.$refs.grouptable.openAddGroupPage();
          break;
        case 'mod':
          this.$refs.grouptable.openModGroupPage();
          break;
        case 'del':
          this.$refs.grouptable.delGroups();
          break;
        case 'addGroupMember':
          this.$refs.grouptable.openAddGroupMemberPage();
          break;
        case 'qryGroupMember':
          this.$refs.grouptable.openQryGroupMemberPage();
          break;
        case 'groupCall':
          this.$refs.grouptable.openGpsGroupCallPage();
          break;
        case 'refresh':
          this.$refs.grouptable.reFreshByNoCondition();
          break;
        case 'search':
          this.$refs.grouptable.openSuperSearchPage();
          break;
        default:
      }
    },
    neClick() {
      this.$refs.grouptable.getGridData(this.$refs.neGms.getNe());
    },
  }
};
</script>

<style scoped>

</style>
